import { render } from "./OnlineCareRequestView.vue?vue&type=template&id=69816bda&scoped=true&ts=true"
import script from "./OnlineCareRequestView.vue?vue&type=script&lang=ts"
export * from "./OnlineCareRequestView.vue?vue&type=script&lang=ts"

import "./OnlineCareRequestView.vue?vue&type=style&index=0&id=69816bda&lang=scss&scoped=true"

import exportComponent from "D:\\Project\\KOMEF\\vuejs-heselcare\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69816bda"]])

export default __exports__